// Route: /collections — LEGACY redirect → /library.
//
// «Коллекции» стали «Папками» и живут внутри Библиотеки левым рельсом
// (обучающая система, docs/plans/LEARNING-SYSTEM-UI.md §2.1). Отдельного
// списка коллекций больше нет.
//
// ВАЖНО: редиректится ТОЛЬКО список. Деталь папки `/collections/$setId`
// остаётся каноничной (BLUEPRINT §0) и здесь не участвует.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

// Валидируем легаси-ключи, чтобы битый URL не падал ДО редиректа.
const searchSchema = z.object({
	sortBy: z.enum(["updatedAt", "createdAt", "name", "materialsCount"]).optional(),
	q: z.string().optional(),
});

export const Route = createFileRoute("/collections/")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		// Раньше здесь было `{ ...search, tab: "folders" } as never`, и каст
		// скрывал сразу две вещи: `sortBy` в схеме `/library` отсутствует, а
		// `tab` она НЕ ЧИТАЕТ ВООБЩЕ (её `validateSearch` знает
		// `filter | q | type | folder | view | demo`). То есть заголовок файла
		// обещал «вкладку Папки», а пользователь приземлялся на обычную
		// Библиотеку — молча, без единой ошибки.
		//
		// Отдельной вкладки папок и нет: рельс папок показан всегда, `folder`
		// по умолчанию уже `__all__`. Переносим единственный совместимый ключ.
		throw redirect({
			to: "/library",
			search: search.q ? { q: search.q } : {},
			replace: true,
		});
	},
});
